export default __webpack_public_path__ + "static/media/07_DAIF_SUSTAINABILITY_04_loop.f685900c.mp4";